import styled from "styled-components";
import { Icon_CircleError } from "../common/CommonIcons";
import { useEffect } from "react";
import { useModalStore } from "src/stores/ModalStore";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { NextButton } from "../common/CommonStyled";

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: center;
    width: 100%;
    justify-content: center;
    font-weight: 600;
    gap: 12px;
`

export const ModalTitle_SchoolSearch = ()=>{
    const modalSetField = useModalStore((state)=>state.setField)
    useEffect(()=>{
        modalSetField('width','370px')
    },[])
    return(
    <TitleWrapper>
        <Icon_CircleError sx={{ width: '28px', height: '28px' }} />
        {/* 검색기능을 사용하기 전에 담당지역을 설정해주세요 */}
    </TitleWrapper>
    )
}

export const ModalContent_SchoolSearch = ()=>{
    return(
        <Typography sx={{ mt: 2, textAlign: 'center', fontSize: '14px', fontWeight: 400 }}>
            검색 기능을 사용하시기 전에 담당지역을 설정해주세요.
        </Typography>
    )
}

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
`

export const ModalFooter_SchoolSearch = ()=>{
    const navigate = useNavigate();
    const setField = useModalStore((state)=>state.setField)

    const onClickNavigate = () =>{
        setField('open',false)
    }

    useEffect(()=>{
        return()=>{
            navigate('/my-info')
        }
    },[])
    return(
        <ButtonWrapper>
            <NextButton onClick={onClickNavigate} style={{ marginTop: '24px' }}>
                확인
            </NextButton>
        </ButtonWrapper>
    )
} 